// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Select from "react-select";
// import privateApi from "../../apis/privateApi";
// import Notification from "../../components/Notification/Notification";
// import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";

// import "./TransactionsCreate.css";

// const TransactionsCreate = () => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const budgetLine = location?.state?.budgetLine;

//     // Form fields
//     const [type, setType] = useState("");
//     const [amount, setAmount] = useState("");
//     const [date, setDate] = useState("");
//     const [description, setDescription] = useState("");

//     // UI state
//     const [loading, setLoading] = useState(false);
//     const [notification, setNotification] = useState({ show: false, message: "", type: "info" });
//     const [confirmOpen, setConfirmOpen] = useState(false);
//     const [confirmToken, setConfirmToken] = useState("");

//     const handleNotificationClose = () =>
//         setNotification(prev => ({ ...prev, show: false }));

//     const generateToken = () =>
//         Math.random().toString(36).substring(2, 8).toUpperCase();

//     // -------------------------
//     // Submit
//     // -------------------------
//     const handleSubmit = e => {
//         e.preventDefault();
//         const token = generateToken();
//         setConfirmToken(token);
//         setConfirmOpen(true);
//     };

//     const handleConfirm = async input => {
//         if (input !== confirmToken) {
//             setNotification({ show: true, message: "Incorrect confirmation code.", type: "error" });
//             setConfirmOpen(false);
//             return;
//         }

//         setConfirmOpen(false);
//         setLoading(true);

//         try {
//             if (!budgetLine) throw new Error("No budget line selected.");

//             const month = new Date(date).getMonth() + 1;

//             const data = {
//                 budgetLineId: budgetLine._id,
//                 type,
//                 amount: Number(amount),
//                 date,
//                 month,
//                 description
//             };

//             await privateApi.post("/api/transactions", data);

//             setNotification({ show: true, message: "Transaction created successfully.", type: "success" });

//             // Reset form
//             setType("");
//             setAmount("");
//             setDate("");
//             setDescription("");
//         } catch (err) {
//             setNotification({
//                 show: true,
//                 message: err.response?.data?.message || "Failed to create transaction.",
//                 type: "error"
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleCancel = () => setConfirmOpen(false);

//     if (!budgetLine) return <p>No budget line selected. Please navigate from the budget line list.</p>;

//     return (
//         <div className="transactions-create">
//             <h2>Create Transaction</h2>

//             <Notification
//                 show={notification.show}
//                 message={notification.message}
//                 type={notification.type}
//                 onClose={handleNotificationClose}
//             />

//             <form onSubmit={handleSubmit}>
//                 <div className="transactions-create-form-group">
//                     <label>Budget Line (Programme)</label>
//                     <input
//                         value={`${budgetLine?.programmeId?.description || ''} - ${budgetLine?.programmeId?.code || ''}`}
//                         readOnly
//                     />
//                 </div>

//                 <div className="transactions-create-form-group">
//                     <label>Type</label>
//                     <Select
//                         options={[
//                             { value: "debit", label: "Debit" },
//                             { value: "credit", label: "Credit" }
//                         ]}
//                         value={type ? { value: type, label: type.charAt(0).toUpperCase() + type.slice(1) } : null}
//                         onChange={opt => setType(opt?.value || "")}
//                         placeholder="Select Type"
//                         isSearchable
//                         isClearable
//                         required
//                     />
//                 </div>

//                 <div className="transactions-create-form-group">
//                     <label>Amount</label>
//                     <input
//                         type="text"
//                         value={amount ? Number(amount.replace(/,/g, '')).toLocaleString() : ''}
//                         onChange={e => {
//                             // Remove all commas and non-digit/decimal characters
//                             const rawValue = e.target.value.replace(/,/g, '');
//                             // Allow only numbers and decimals
//                             if (!isNaN(rawValue) || rawValue === '') {
//                                 setAmount(rawValue);
//                             }
//                         }}
//                         placeholder="Enter amount"
//                         required
//                     />
//                 </div>

//                 <div className="transactions-create-form-group">
//                     <label>Date</label>
//                     <input
//                         type="date"
//                         value={date}
//                         onChange={e => setDate(e.target.value)}
//                         required
//                     />
//                 </div>

//                 <div className="transactions-create-form-group">
//                     <label>Description</label>
//                     <textarea
//                         type="text"
//                         value={description}
//                         onChange={e => setDescription(e.target.value)}
//                         placeholder="Description"
//                         required
//                     />
//                 </div>

//                 <div className="transactions-create-action-buttons">
//                     <button type="submit" className="transactions-create-btn" disabled={loading}>
//                         {loading ? "Creating..." : "Create Transaction"}
//                     </button>

//                     <button
//                         onClick={() => navigate(-1)}
//                         className="transactions-create-back-btn"
//                         type="button"
//                     >
//                         Back
//                     </button>
//                 </div>
//             </form>

//             <ConfirmDialog
//                 show={confirmOpen}
//                 token={confirmToken}
//                 action="You are about to create a new transaction"
//                 onConfirm={handleConfirm}
//                 onCancel={handleCancel}
//             />
//         </div>
//     );
// };

// export default TransactionsCreate;

import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import privateApi from "../../apis/privateApi";
import Notification from "../../components/Notification/Notification";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import "./TransactionsCreate.css";

/* ─── react-select styles ────────────────────────────────────── */
const rsStyles = {
    control: (b, s) => ({
        ...b,
        borderColor: s.isFocused ? "#006B3C" : "#D2DDD5",
        boxShadow: s.isFocused ? "0 0 0 3px rgba(0,107,60,.18)" : "none",
        "&:hover": { borderColor: "#006B3C" },
        borderRadius: 6, fontSize: 13, minHeight: 38,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        background: "#F0F4F1",
        transition: "border-color .18s, box-shadow .18s",
    }),
    option: (b, s) => ({
        ...b, fontSize: 13,
        background: s.isSelected ? "#006B3C" : s.isFocused ? "rgba(0,107,60,.07)" : "#fff",
        color: s.isSelected ? "#fff" : "#0E1F14",
    }),
    menu: (b) => ({
        ...b, zIndex: 9999, borderRadius: 10,
        border: "1px solid #D2DDD5",
        boxShadow: "0 12px 40px rgba(1,45,26,.16)",
    }),
    menuPortal: (b) => ({ ...b, zIndex: 9999 }),
    placeholder: (b) => ({ ...b, color: "#9BB0A0", fontSize: 13 }),
    singleValue: (b) => ({ ...b, color: "#0E1F14" }),
};

const TransactionsCreate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const budgetLine = location?.state?.budgetLine;

    const [type, setType] = useState("");
    const [amount, setAmount] = useState("");
    const [date, setDate] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ show: false, message: "", type: "info" });
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmToken, setConfirmToken] = useState("");

    const handleSubmit = e => {
        e.preventDefault();
        const token = Math.random().toString(36).substring(2, 8).toUpperCase();
        setConfirmToken(token);
        setConfirmOpen(true);
    };

    const handleConfirm = async input => {
        if (input !== confirmToken) {
            setNotification({ show: true, message: "Incorrect confirmation code.", type: "error" });
            setConfirmOpen(false);
            return;
        }
        setConfirmOpen(false);
        setLoading(true);
        try {
            if (!budgetLine) throw new Error("No budget line selected.");
            await privateApi.post("/api/transactions", {
                budgetLineId: budgetLine._id,
                type,
                amount: Number(amount),
                date,
                month: new Date(date).getMonth() + 1,
                description,
            });
            setNotification({ show: true, message: "Transaction created successfully.", type: "success" });
            setType(""); setAmount(""); setDate(""); setDescription("");
        } catch (err) {
            setNotification({
                show: true,
                message: err.response?.data?.message || "Failed to create transaction.",
                type: "error",
            });
        } finally { setLoading(false); }
    };

    if (!budgetLine) return (
        <div className="tx-page-centered">
            <p style={{ color: "var(--muted)", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>
                No budget line selected. Please navigate from the budget line list.
            </p>
        </div>
    );

    /* Budget line context display */
    const progLabel = [
        budgetLine?.programmeId?.description,
        budgetLine?.programmeId?.code,
    ].filter(Boolean).join(" — ") || "—";

    const locationName = budgetLine?.stateId?.name || budgetLine?.lgaId?.name || "";

    return (
        <div className="tx-page-centered">
            <div className="tx-create-card">

                {/* Card header */}
                <div className="tx-create-card-header">
                    <h2>Create Transaction</h2>
                    <p>Post a debit or credit against a budget line</p>
                </div>

                <Notification
                    show={notification.show}
                    message={notification.message}
                    type={notification.type}
                    onClose={() => setNotification(p => ({ ...p, show: false }))}
                />

                <form className="tx-create-form-body" onSubmit={handleSubmit}>

                    {/* Context chip */}
                    {locationName && (
                        <div className="tx-context-chip">📍 {locationName}</div>
                    )}

                    {/* Budget line (read-only) */}
                    <div className="tx-form-group">
                        <label className="tx-label">Budget Line (Programme)</label>
                        <input className="tx-input" value={progLabel} readOnly />
                    </div>

                    <div className="tx-divider-line" />
                    <div className="tx-section-title">Transaction Details</div>

                    {/* Type */}
                    <div className="tx-form-group">
                        <label className="tx-label required">Type</label>
                        <div className="tx-rs-wrap">
                            <Select
                                styles={rsStyles}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                options={[
                                    { value: "debit", label: "Debit" },
                                    { value: "credit", label: "Credit" },
                                ]}
                                value={type ? { value: type, label: type.charAt(0).toUpperCase() + type.slice(1) } : null}
                                onChange={opt => setType(opt?.value || "")}
                                placeholder="Select transaction type…"
                                isSearchable
                                isClearable
                            />
                        </div>
                    </div>

                    {/* Amount */}
                    <div className="tx-form-group">
                        <label className="tx-label required">Amount</label>
                        <div className="tx-amount-wrap">
                            <span className="tx-amount-prefix">₦</span>
                            <input
                                className="tx-input tx-amount-input"
                                type="text"
                                required
                                placeholder="0"
                                value={amount ? Number(amount.replace(/,/g, '')).toLocaleString() : ''}
                                onChange={e => {
                                    const raw = e.target.value.replace(/,/g, '');
                                    if (!isNaN(raw) || raw === '') setAmount(raw);
                                }}
                            />
                        </div>
                    </div>

                    {/* Date */}
                    <div className="tx-form-group">
                        <label className="tx-label required">Transaction Date</label>
                        <input
                            className="tx-input"
                            type="date"
                            required
                            value={date}
                            onChange={e => setDate(e.target.value)}
                        />
                    </div>

                    {/* Description */}
                    <div className="tx-form-group">
                        <label className="tx-label required">Description</label>
                        <textarea
                            className="tx-textarea"
                            required
                            placeholder="Enter a brief description of this transaction…"
                            value={description}
                            onChange={e => setDescription(e.target.value)}
                        />
                    </div>

                    {/* Actions */}
                    <div className="tx-form-actions">
                        <button type="button" className="tx-btn tx-btn-secondary" onClick={() => navigate(-1)}>
                            ← Back
                        </button>
                        <button type="submit" className="tx-btn tx-btn-primary" disabled={loading}>
                            {loading ? "Creating…" : "✓ Create Transaction"}
                        </button>
                    </div>
                </form>
            </div>

            <ConfirmDialog
                show={confirmOpen}
                token={confirmToken}
                action="You are about to create a new transaction"
                onConfirm={handleConfirm}
                onCancel={() => setConfirmOpen(false)}
            />
        </div>
    );
};

export default TransactionsCreate;